module.exports = __webpack_public_path__ + "static/media/polygon-marker.ce36ac00.svg";